var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"section-bg mt-10 mb-4"},[_c('h4',{staticClass:"section-label"},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }